import { Component, Fragment } from 'react';

class Modal extends Component {

    render(){
        return(
            <Fragment>
            {this.props.modalShow ?
                <div className="custom-modal">
                    <div className="custom-modal-content">
                        <div className="custom-modal-header">
                            <div className="d-flex justify-content-between align-items-center">
                                <div><h6>{this.props.title}</h6></div>
                                <div>
                                    <button className="btn p-0 btn-close-2" onClick={this.props.show}>
                                        <i className="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="right-body text-center text-white">
                            <div>
                                {parseInt(this.props.response) !== 200 ?
                                    <>
                                        <p>{this.props.error}</p>
                                        <i className="fa fa-times text-danger fa-5x ml-auto mr-auto mb-2 mt-1 d-block"></i>
                                    </>
                                    :
                                    <>
                                        <p>{this.props.success}</p>
                                        <i className="fa fa-check text-sussess fa-5x ml-auto mr-auto mb-2 mt-1 d-block"></i>
                                    </>
                                }
                            </div>
                        </div>

                        <div className="right-footer d-flex justify-content-center align-items-stretch">
                            <button className="btn btn-outline-grey mr-2" onClick={this.props.show}>
                                    Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            :
                <></>
            }
            </Fragment>
        )
    }
}

export default Modal;